let styleBuffer = '';
const fullTextStorage = {};

export default function writeChar(el, char, style){
  // Pegar o texto. Nós carregamos isso no armazenamento então nós não temos que ler do DOM cada interação.
  let fullText = fullTextStorage[el.id];
  if (!fullText) fullText = fullTextStorage[el.id] = el.innerHTML;

  fullText = handleChar(fullText, char);
  // Mas nós ainda escrevemos no DOM cada interação, o que pode ficar muito lento.
  el.innerHTML = fullTextStorage[el.id] = fullText;

  // Buffer escreve no elemento <style> então nós não temos que ficar colorindo.
  styleBuffer += char;
  if (char === ';') {
    style.textContent += styleBuffer;
    styleBuffer = '';
  }
};

export function writeSimpleChar(el, char) {
  el.innerHTML += char;
};

let openComment = false;
const commentRegex = /(\/\*(?:[^](?!\/\*))*\*)$/;
const keyRegex = /([a-zA-Z- ^\n]*)$/;
const valueRegex = /([^:]*)$/;
const selectorRegex = /(.*)$/;
const pxRegex = /\dp/;
const pxRegex2 = /p$/;

export function handleChar(fullText, char) {
  if (openComment && char !== '/') {
    // Circuito curto durante um comentário nós não realçamos dentro dele.
    fullText += char;
  } else if (char === '/' && openComment === false) {
    openComment = true;
    fullText += char;
  } else if (char === '/' && fullText.slice(-1) === '*' && openComment === true) {
    openComment = false;
    // Infelizmente não não conseguimos apenas abrir um <span> e fechar, porque o navegador utilizará
    // uma 'correção' para nós, e ficaremos apenas com um caracter e o <span> fechará com uma tag vazia.
    fullText = fullText.replace(commentRegex, '<span class="comment">$1/</span>');
  } else if (char === ':') {
    fullText = fullText.replace(keyRegex, '<span class="key">$1</span>:');
  } else if (char === ';') {
    fullText = fullText.replace(valueRegex, '<span class="value">$1</span>;');
  } else if (char === '{') {
    fullText = fullText.replace(selectorRegex, '<span class="selector">$1</span>{');
  } else if (char === 'x' && pxRegex.test(fullText.slice(-2))) {
    fullText = fullText.replace(pxRegex2, '<span class="value px">px</span>');
  } else {
    fullText += char;
  }
  return fullText;
}
